export default __webpack_public_path__ + "static/impact-strategies-logo-light-4c69cdc6d7e367b7af3ed3e53dca90bb.png";